module.exports = __webpack_public_path__ + "img/poster-2.d1cfc36b.png";